
<form #createForm="ngForm" (ngSubmit)="onSubmit()">
      <h2 mat-dialog-title>Create Crypto</h2>

      <mat-dialog-content>
        <section>
            <mat-button-toggle-group #side [(ngModel)]="crypto.side" [value]="crypto.side" name="crypto.side" hideSingleSelectionIndicator="true" style="width: 99%;">        
                <mat-button-toggle value="BUY" style="width: 50%;">Buy</mat-button-toggle>
                <mat-button-toggle value="SELL" style="width: 50%;">Sell</mat-button-toggle>
            </mat-button-toggle-group>
        </section>

        <mat-divider></mat-divider>
        <mat-divider></mat-divider>
        <mat-divider></mat-divider>

          <mat-form-field>
              <mat-label>Coin</mat-label>
              <mat-select style="height: 16px;" #share [(ngModel)]="crypto.share" name="crypto.share" required>
                <mat-option *ngFor="let s of shares;" value="{{s.code}}">{{s.code}}</mat-option>
              </mat-select>
              <mat-hint *ngIf="shares?.length === 0">Cadastre a moeda em Shares com tipo Crypto</mat-hint>
          </mat-form-field>
            &nbsp;&nbsp;
          <mat-form-field>
              <mat-label>Operation Date</mat-label>
              <input matInput [matDatepicker]="datepicker" (ngModelChange)="crypto.date=$event._d;" (dateChange)="loadMarketData($event.value)" [ngModel]="crypto.date.seconds * 1000 | date: 'YYYY-MM-dd'" name="crypto.date" />
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker touchUi #datepicker></mat-datepicker>
          </mat-form-field>

          <mat-divider></mat-divider>

          <mat-form-field>
              <mat-label>Amount</mat-label>
              <input matInput type="number" step="any" min="0" [ngModel]="crypto.amount" name="crypto.amount" placeholder="0.00000000" required>
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field>
              <mat-label>Price</mat-label>
              <input matInput type="text" currency [ngModel]="crypto.price | number:'1.2-2' | currency" name="crypto.price" placeholder="0.00" required>
          </mat-form-field>
          
          <mat-divider></mat-divider>
  
          <mat-form-field>
              <mat-label>Tax</mat-label>
              <input matInput type="text" currency [ngModel]="crypto.tax | number:'1.2-2' | currency" name="crypto.tax" placeholder="0.00" required>
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field>
              <mat-label>Total</mat-label>
              <input matInput type="text" currency [ngModel]="crypto.total | number:'1.2-2' | currency" name="crypto.total" placeholder="0.00" readonly>
          </mat-form-field>

          <mat-divider></mat-divider>

          <mat-form-field>
              <mat-label>USD/BRL (PTAX)</mat-label>
              <input matInput type="number" step="any" min="0" [(ngModel)]="crypto.usdBrl" name="crypto.usdBrl" placeholder="0.0000">
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field>
              <mat-label>BTC (USD)</mat-label>
              <input matInput type="number" step="any" min="0" [(ngModel)]="crypto.btcUsd" name="crypto.btcUsd" placeholder="0.00">
          </mat-form-field>
          <p *ngIf="loadingMarketData">Buscando cotações...</p>
          
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button type="submit" [disabled]="createForm.invalid">Add</button>
          <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
        </mat-dialog-actions>

    </form>